/**
 * Before After Image Block - Save Component
 *
 * Returns null because this is a dynamic block rendered via render.php.
 * The server-side render.php handles all frontend output with
 * WordPress Interactivity API directives.
 *
 * @package BrandyBlocks
 */

export default function Save() {
	return null;
}
